import React from 'react';
import { OverlayComponent } from 'app/components';
import { hasTranslationsValid } from 'app/components/translation/has-translations-valid';
import { validateExternalUrlGroup } from '../utils/validate-external-url-group';
import { ExternalUrlGroupsContainerProps } from '../types';
import { ExternalUrlGroupStickyHeader } from './external-url-group-sticky-header';

export const ExternalUrlGroupsContainer: React.FC<ExternalUrlGroupsContainerProps> = ({
  actionType, formState, externalUrls, shouldPrompt, mainLanguage, translation, children, switchTranslationsToggle,
  description, longDescription, deleteExternalUrlGroup, saveExternalUrlGroup, updateValidation, displayError
}) => {

  const { externalUrlGroupItem, fetching, saving, deleting, languageOptions, validation } = formState;

  const onSave = () => {
    const formValidation = validateExternalUrlGroup(externalUrlGroupItem, languageOptions, translation);
    updateValidation({ ...validation, ...formValidation });
    if (Object.keys(formValidation).length > 0) {
      !hasTranslationsValid(formValidation.language, mainLanguage) && switchTranslationsToggle(true);
      displayError(translation.external_url_validation_error);
      return;
    }
    saveExternalUrlGroup(externalUrlGroupItem);
  };

  const externalUrlGroupName = externalUrlGroupItem.language
    ?.find(languageItem => languageItem.value === mainLanguage)
    ?.description;

  return <>
    <OverlayComponent
      displayOverlay={saving || deleting}
      overlayText={saving
        ? translation.saving_external_url_group
        : translation.deleting_external_url_group} />
    <ExternalUrlGroupStickyHeader
      actionType={actionType}
      shouldPrompt={shouldPrompt}
      description={description}
      longDescription={longDescription}
      externalUrlGroupItem={externalUrlGroupItem}
      name={externalUrlGroupName}
      externalUrls={externalUrls}
      fetching={fetching}
      displayError={displayError}
      onSave={onSave}
      onDelete={deleteExternalUrlGroup}
      translation={translation} />
    {children}
  </>;
};
